import { Component, inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { ButtonPadraoComponent } from "../../components/button-padrao/button-padrao.component";

@Component({
  selector: 'app-modal-visualizacao-json',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, ButtonPadraoComponent],
  templateUrl: './modal-visualizacao-json.html',
  styleUrl: './modal-visualizacao-json.css'
})
export class ModalVisualizacaoJson implements OnInit{
  public dialog = inject<MatDialogRef<ModalVisualizacaoJson>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.texto = this.data.texto
  }

  texto = "";
}
